<template>
  <Roles class="project-roles" :value="items" />
</template>

<script>
import { mapState } from 'vuex'
import Roles from '@/components/Roles'

export default {
  computed: {
    ...mapState('Project', ['item']),
    items() {
      return this.$path('item.roles.salesman') || []
    },
  },
  components: {
    Roles,
  },
}
</script>
